/**
 * Elements with selector ".js-clickable" are made clickable using the first
 * child link found.
 */
(function($){
    $('.js-clickable').each(function(){
        var link = $('a[href]', this).eq(0).attr('href');
        if (!link) return true;
        $(this).on('click', function(e){
            if (e.metaKey) {
                open(link, '_blank');
            } else {
                location.href = link;
            }
        });
    });
})(jQuery);
